<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div class="mt-16 flex-row">
    <div class="flex-1">
      <mat-slide-toggle formControlName="allowFlow" color="primary" (change)="onAllowFlowChange()">
        <label class="form-label">Tiers enabled</label>
      </mat-slide-toggle>
    </div>
    <div class="text-right">
      @if (!!form.value.allowFlow) {
        <lib-button [disabled]="isDisableTier" icon="add" tooltip="Add first step" (buttonClick)="addStep()">Add
          step</lib-button>
      }
    </div>
  </div>

  @if (_strategyType == 'Stamps') {
    @if (!!form.value.allowFlow == false) {
      <app-stamp-setting #stampSetting [strategy]="strategy" [advertiserId]="advertiserId" strategyType="Stamps"
        [campaignId]="campaignId" [isCloning]="isCloning"></app-stamp-setting>
    }
    @if (!!form.value.allowFlow == true) {
    <div fxLayout="row" [style.marginBottom.px]="20">
      <div fxLayout="column" fxFlex="50%">
        <div class="box space-top">
          <h5>Card Restart Limit</h5>
          <div fxLayout="row">
            <mat-form-field fxFlex>
              <mat-label>Limit number of completes</mat-label>
              <input matInput type="number" placeholder="" formControlName="restartLimit" maxlength="100"
                autocomplete="off" step="1">
              @if (!form.get('restartLimit').valid) {
              <mat-error>Please enter the max no of
                completes</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    }
  }

  <div [style.display]="!!form.value.allowFlow ? 'block' : 'none'" fxLayout="column">
    <!--
      <pre>
        {{ form.value | json }}
      </pre> -->

    @for (grp of form.controls.steps['controls']; track grp; let i = $index) {
      <div fxLayout="column" fxLayoutAlign="start space-between" fxLayoutGap="5px" [style.marginTop.px]="20"
        class="step-item">
        <!-- Header -->
        <div class="flex-row align-center">
          <div class="section-title flex-1">Step {{ i+1 }} @if (grp.value['restartLimit'] > 0) {
            <span>(repeat {{grp.value['restartLimit']}} times)</span>
            }
          </div>
          <div class="text-right">
            @if (grp.value['isNewStep']) {
              <lib-button icon="delete" tooltip="Remove step" (buttonClick)="removeStep(i)">Remove step</lib-button>
            }
          </div>
        </div>
        <!-- Body -->
        <div fxFlex class="box space-bottom" fxLayout="column" fxLayoutGap="20px">
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex fxLayout="column" fxLayoutGap="5px">
              @if (captureToolType != receiptToolTypes.UniqueSafebox) {
                <mat-form-field fxFlex>
                  <mat-label>Scheme</mat-label>
                  <mat-select [formControl]="grp['controls'].schemaId" (selectionChange)="onSchemeChange($event)">
                    @for (s of schemes; track s) {
                    <mat-option [value]="s.id">{{ s.name || '[No Scheme Name]' }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <mat-form-field fxFlex>
                <mat-label>Title</mat-label>
                <input type="text" matInput placeholder="" [formControl]="grp['controls'].title" autocomplete="off">
                @if (grp.get('title').touched && !grp.get('title').valid) {
                <mat-error>Please enter a title for this
                  step</mat-error>
                }
              </mat-form-field>
              <div fxFlex fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                  <mat-label>{{placeHolderCompleteStep}}</mat-label>
                  <input type="number" matInput placeholder="" [formControl]="grp['controls'].maxStampCount" step="1"
                    autocomplete="off">
                  @if (grp.get('maxStampCount').touched && !grp.get('maxStampCount').valid) {
                  <mat-error>Please enter
                    number of {{strategy.strategyType === 'Points' ? 'points' : 'stamps'}} to complete the
                    step</mat-error>
                  }
                </mat-form-field>
                <mat-form-field fxFlex>
                  <mat-label>Repeat step</mat-label>
                  <input matInput type="number" placeholder="" [formControl]="grp['controls'].restartLimit"
                    maxlength="100" autocomplete="off" step="1">
                  @if (grp.get('restartLimit').touched && !grp.get('restartLimit').valid) {
                  <mat-error>Please enter number
                    of times to repeat this step</mat-error>
                  }
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <mat-form-field fxFlex>
                  <mat-label>Complete step reward</mat-label>
                  <mat-select [formControl]="grp['controls'].completeReward"
                    (selectionChange)="onRewardSelected($event['value'], i)" placeholder="">
                    <mat-option [value]="null"></mat-option>
                    @for (data of rewardProductsOptions; track data) {
                    <mat-option [value]="data" [matTooltip]="data.productReward?.productSlug">{{
                      data.productReward?.rewardTitle }}</mat-option>
                    }
                  </mat-select>
                  @if ((grp.touched && !grp.get('completeReward').valid)) {
                  <mat-error>Please select the complete step
                    reward</mat-error>
                  }
                </mat-form-field>
                <div fxFlex="40px">
                  @if (!hasProductReward(grp)) {
                    <lib-button variant="icon" color="primary" icon="add_circle" tooltip="Add reward product" (buttonClick)="onAddRewardProduct(grp)">Add Reward Product</lib-button>
                  }
                  @if (hasProductReward(grp)) {
                    <lib-button variant="icon" color="primary" icon="delete" tooltip="Remove reward product" (buttonClick)="onRemoveRewardProduct(grp)">Remove Reward Product</lib-button>
                  }
                </div>
              </div>
            </div>
            <!-- Col right -->
            <div fxFlex fxLayout="column" fxLayoutAlign="center start">
              @if (grp.value['completeReward']) {
              <div fxLayout="column" fxLayoutAlign="start">
                @if (grp.value['completeReward'].productReward; as p) {
                <div fxFlex fxLayout="row" fxLayoutGap="20px">
                  <div class="reward-photo">
                    <lib-photo [url]="p.rewardPhotoUrl" [width]="'153px'" [height]="'153px'"
                      [radius]="'10px'"></lib-photo>
                  </div>
                  <div fxFlex fxLayout="column" fxLayoutAlign="start">
                    @if (p?.rewardTitle) {
                    <div class="info-v">
                      <div class="lbl">Reward title</div>
                      <div class="val" [innerHTML]="p.rewardTitle"></div>
                    </div>
                    }
                    @if (p?.rewardDescription) {
                    <div class="info-v">
                      <div class="lbl">Reward description</div>
                      <div class="val" [innerHTML]="p.rewardDescription"></div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
          </div>
          <div fxLayout="row" class="mat-typography" fxLayoutGap="20px" style="margin-top: 20px;">
            <div fxFlex fxFlexAlign="stretch end">
              <app-reward-select [advertiserId]="advertiserId" [title]="'Level unlock reward'"></app-reward-select>
            </div>
          </div>
          <div fxFlex>
            <app-campaign-banner [formControl]="grp['controls'].banner"></app-campaign-banner>
            <!-- Banner: <pre>{{ grp.value.banner | json }}</pre> -->
          </div>
        </div>
      </div>
    }

  </div>
</form>

<lib-loading-overlay [isLoading]="isLoading" [message]="'loading...'" />
